import {State} from '../types/state'
import {getEvent} from './event'

export const getCalendarLinks = (state: State) => state.calendarLinks || getEvent(state).calendarLinks
